import { Box, Typography } from '@mui/material';
import Actionbuttons from 'components/common/actions-buttons';
import TableComponent from 'components/Table';
import { TextButton } from 'components/TextButton';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoney } from 'utils/helpers';
import { AccountingLoanEntry } from 'v2-types/order';

import { useStyles } from '../../styles';
import { ModalData } from '../../types';
import { formatPercent } from '../../utils';

type Props = {
  setModalData: React.Dispatch<React.SetStateAction<ModalData | undefined>>,
  isDataLoading: boolean,
  isUpdateLoading: boolean,
  loanAmountEntry?: AccountingLoanEntry
}

export const Additional: FC<Props> = ({
  setModalData,
  isDataLoading,
  isUpdateLoading,
  loanAmountEntry
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box>
      <Box style={{
        display: 'flex', gap: '20px', height: '50px', alignItems: 'flex-start', justifyContent: 'space-between'
      }}
      >
        <Typography variant="h6" className={classes.subTitle}>
          {t('loan:additional')}
        </Typography>
        <TextButton
          icon="plus"
          text={t('loan:add-additional')}
          textColor="#FB8C00"
          disabled={isDataLoading || isUpdateLoading}
          onClick={() => setModalData({ modal: 'createAdditional' })}
        />
      </Box>

      {loanAmountEntry && loanAmountEntry.involved_parties && loanAmountEntry.involved_parties.length > 0 && (
        <Box>
          <TableComponent
            disabledBorderLeft
            cellAlignment="left"
            columns={{
              actions: {
                header: { title: t('accounting:actions'), width: '100px' },
                renderer: ({ row }) => (
                  <Actionbuttons
                    handleEdit={() => setModalData({ modal: 'editPartyEntry', entry: row })}
                    handleDelete={() => setModalData({ modal: "deleteAdditional", entry: row })}
                  />
                )
              },
              name: {
                header: { title: t('accounting:description'), align: 'left' },
                renderer: ({ row }) => <>{row.kind}</>,
              },
              amount: {
                header: { title: t('accounting:amount'), align: 'left' },
                renderer: ({ row }) => <>{`${formatMoney(row?.amount || 0, 2)} (${formatPercent((row?.percent || 0))})`}</>,
              }
            }}
            dataSet={loanAmountEntry?.involved_parties || []}
          />
        </Box>
      )}
      {loanAmountEntry && loanAmountEntry.involved_parties && loanAmountEntry.involved_parties.length === 0 && (
        <Typography className={classes.placeholderText}>
          {t('loan:not-additional')}
        </Typography>
      )}
    </Box>
  );
};
